import { branch, renderNothing } from 'recompose'
import { locationSelector } from 'sfproxy/selectors'
import AccessModesComponent from 'car-parks/components/accessModes/AccessModes'

const AccessModes = ({ access, geoLocation, what3Words }) => (
    <AccessModesComponent access={{ ...access }} links={{ what3Words }} geoLocation={geoLocation} />
)

export default compose(
    connect(locationSelector),
    branch(
        ({ access, what3Words }) => (!access || Object.values(access).filter(Boolean).length === 0) && !what3Words,
        renderNothing
    )
)(AccessModes)
